"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const helpers_1 = require("../helpers");
const LocalStorage_1 = __importDefault(require("./LocalStorage"));
const GhostStorage_1 = __importDefault(require("./GhostStorage"));
class InternalStorageFactory {
    static getInstance() {
        if ((0, helpers_1.isBrowser)())
            return new LocalStorage_1.default();
        if ((0, helpers_1.isGoogleServerless)())
            return new GhostStorage_1.default();
        // eslint-disable-next-line global-require
        const CredentialsStorage = require('./CredentialsStorage'); // TODO change it to use async import
        const CredStor = CredentialsStorage.default;
        const cs = new CredStor();
        return cs;
    }
}
exports.default = InternalStorageFactory;
//# sourceMappingURL=InternalStorageFactory.js.map